import React, { useEffect } from 'react';

const ScrollToTopOnMount = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            {/* Contenuto del componente */}
        </div>
    );
};

export default ScrollToTopOnMount;
